import React, { useEffect, useState } from 'react';
const supportEmail = process.env.SSUPPORT_EMAIL || 'tryjaca@gmail.com';

const VendorCashOut = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});
  const [message, setMessage] = useState('');
  const loggedInUser = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    fetchInvoices();
    // eslint-disable-next-line
  }, []);

  const fetchInvoices = async () => {
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/vendor/invoices/${loggedInUser.id}`);
      const data = await res.json();
      if (res.ok && data.invoices) {
        setInvoices(data.invoices);
      } else {
        setMessage(data.message || 'Failed to fetch invoices');
      }
    } catch {
      setMessage('Error fetching invoices');
    }
    setLoading(false);
  };

  const handleCashOut = async (invoiceId, amount) => {
    setProcessing(prev => ({ ...prev, [invoiceId]: true }));
    setMessage('');
    try {
      // Generate a mock Stripe reference code (replace with actual Stripe integration)
      const stripeRefCode = `stripe_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  const res = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/invoice/cashout/${invoiceId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vendor_id: loggedInUser.id,
          amount,
          stripe_ref_code: stripeRefCode
        })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setMessage('Cash out processed successfully!');
        fetchInvoices();
        // Send email to support
        try {
          await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/send-mail`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              from: loggedInUser.email,
              to: supportEmail,
              subject: `Cash Out Requested by Vendor #${loggedInUser.id}`,
              message: `Vendor #${loggedInUser.id} (${loggedInUser.email}) requested a cash out for Invoice #${invoiceId} with amount $${amount}. Reference: ${stripeRefCode}`
            })
          });
        } catch (e) {
          // Optionally handle email error
        }
      } else {
        setMessage(data.message || 'Cash out failed');
      }
    } catch {
      setMessage('Error processing cash out');
    }
    setProcessing(prev => ({ ...prev, [invoiceId]: false }));
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`;
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Vendor Cash Out Request</h2>
      <div style={{
        background: '#fffde7',
        color: '#8d6e36',
        padding: '14px',
        borderRadius: '8px',
        marginBottom: '18px',
        textAlign: 'center',
        fontWeight: 'bold',
        border: '1px solid #ffe082',
        fontSize: '1.08rem',
      }}>
        Cash out requests will be received by our system, and we will zelle over the payment to your email address on file. Please update your email address to the one associated with your zelle account. Please contact <a href={`mailto:${supportEmail}`}>{supportEmail}</a>, if you have any questions or need to change your pay out method.
      </div>
      {message && <div style={styles.message}>{message}</div>}
      {loading ? (
        <div style={styles.loading}>Loading invoices...</div>
      ) : invoices.length === 0 ? (
        <div style={styles.empty}>No invoices available for cash out.</div>
      ) : (
        <div style={styles.invoiceGrid}>
          {invoices.map(invoice => (
            <div key={invoice.id} style={styles.invoiceCard}>
              <div style={styles.invoiceHeader}>
                <div style={styles.invoiceId}>Invoice #{invoice.id}</div>
                <div style={styles.amount}>${(invoice.amount / 1.1).toFixed(2)}</div>
                <div 
                  style={{
                    ...styles.statusBadge,
                    backgroundColor: invoice.cashed_out ? '#388e3c' : '#ff9800'
                  }}
                >
                  {invoice.cashed_out ? 'Cash Out Requested' : 'Available'}
                </div>
              </div>
              <div style={styles.invoiceDetails}>
                <p><strong>Date:</strong> {formatDate(invoice.date)}</p>
                <p><strong>Time:</strong> {invoice.start_time} - {invoice.end_time}</p>
                {invoice.cashed_out ? (
                  <>
                    <p><strong>Request Date:</strong> {formatDate(invoice.cashed_out_date)}</p>
                    <p><strong>Reference:</strong> {invoice.stripe_ref_code}</p>
                  </>
                ) : null}
              </div>
              <div style={styles.actions}>
                {!invoice.cashed_out ? (
                  <button
                    style={styles.cashOutBtn}
                    onClick={() => handleCashOut(invoice.id, invoice.amount)}
                    disabled={processing[invoice.id]}
                  >
                    {processing[invoice.id] ? 'Processing...' : 'Cash Out Request'}
                  </button>
                ) : (
                  <div style={styles.cashedOut}>
                    ✓ Processed on {formatDate(invoice.cashed_out_date)}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '32px',
    background: '#e3f2fd',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(25,118,210,0.10)',
    minHeight: '80vh',
  },
  title: {
    color: '#1976d2',
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '28px',
    textAlign: 'center',
  },
  message: {
    background: '#fffde7',
    color: '#8d6e36',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '18px',
    textAlign: 'center',
    fontWeight: 'bold',
    border: '1px solid #ffe082',
  },
  loading: {
    textAlign: 'center',
    color: '#1976d2',
    fontSize: '1.2rem',
    marginTop: '40px',
  },
  empty: {
    textAlign: 'center',
    color: '#666',
    fontSize: '1.1rem',
    padding: '40px',
    fontStyle: 'italic',
    background: '#fff',
    borderRadius: '8px',
    marginTop: '30px',
  },
  invoiceGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
    gap: '24px',
  },
  invoiceCard: {
    background: '#fff',
    border: '1px solid #bbdefb',
    borderRadius: '10px',
    padding: '22px',
    boxShadow: '0 2px 8px rgba(25,118,210,0.07)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '220px',
  },
  invoiceHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
    gap: '10px',
    flexWrap: 'wrap',
  },
  invoiceId: {
    fontWeight: 'bold',
    color: '#1976d2',
    fontSize: '1.1rem',
  },
  amount: {
    fontWeight: 'bold',
    color: '#388e3c',
    fontSize: '1.15rem',
    background: '#e8f5e9',
    padding: '4px 12px',
    borderRadius: '8px',
  },
  statusBadge: {
    color: '#fff',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '0.95rem',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    minWidth: '90px',
    textAlign: 'center',
  },
  invoiceDetails: {
    marginBottom: '14px',
    color: '#555',
    fontSize: '1rem',
  },
  actions: {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  cashOutBtn: {
    background: '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 24px',
    fontWeight: 'bold',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #bbdefb',
    transition: 'background 0.2s',
  },
  cashedOut: {
    color: '#388e3c',
    fontWeight: 'bold',
    fontSize: '1rem',
    background: '#e8f5e9',
    padding: '6px 12px',
    borderRadius: '8px',
  },
};

export default VendorCashOut;